module.exports = __webpack_public_path__ + "static/media/banner.796a3ffe.svg";